import { ColorTranslator } from 'colortranslator';

export const getDarkenedColor = (hex: string, lum: number): string | undefined => {
  if (hex) {
    try {
      const c = new ColorTranslator(hex);
      const hslaString = `hsla(${c.H}, ${c.S}%, ${lum * 100}%, ${c.A})`;
      return hslaString;
    } catch (e) {
      console.error('Error darkening color:', e);
      return undefined;
    }
  }
  return undefined;
};

/**
 * Converts a hex color to a 1x1 base64 SVG data URL.
 * Useful for placeholderSrc in react-lazy-load-image-component.
 */
export const colorToDataUrl = (color: string): string => {
  if (!color || !color.startsWith('#')) return '';
  
  // Create a minimal 1x1 SVG with the background color
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="1" height="1"><rect width="1" height="1" fill="${color}"/></svg>`;
  
  // Encode as base64
  try {
    const base64 = typeof window !== 'undefined' ? window.btoa(svg) : Buffer.from(svg).toString('base64');
    return `data:image/svg+xml;base64,${base64}`;
  } catch (e) {
    console.error('Error creating color data URL:', e);
    return '';
  }
};
